import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Row, Col, Radio, InputNumber, Icon, Modal, Button, Select } from 'antd';


import { IconFacebookSquare, IconTwitterSquare, IconLinkedinSquare } from '../../../../../../../data/assets/icons';
import { AGENT_STATUS } from '../../../../../../../data/config/constants';
import CommonForm from '../../../../../../../components/commonform';
import { resetPassWord } from '../../../../../../../data/redux/member_details/actions';
import { showMessage } from '../../../../../../../data/config/utils';

import InputItem from '../../../../../../../components/form/inputitem';
import TextareaItem from '../../../../../../../components/form/textareaitem';
import SocialInputItem from '../../../../../../../components/form/socialinputitem';

const { Option } = Select;

class AgentForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      reset_modal_data: {
        resetPassword: false,
        password: "",
        confirmPassword: ""
      }
    }
  }

  filterOption = (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

  onChangeAgentInfo = event => {
    if (event.target.name) {
      this.props.onChange(event.target.name, event.target.value);
    }
  };

  onChangeSocialLinks = event => {
    if (event.target.name) {
      const { agent } = this.props;
      const socialLinks = { ...agent.socialLinks, [event.target.name]: event.target.value };
      this.props.onChange('socialLinks', socialLinks);
    }
  };

  onChangeChatConcurrency = count => {
    this.props.onChange('chatConcurrency', count);
  };

  onChangeAgentParent = parentPsid => {
    this.props.onChange('parentPsid', parentPsid === undefined ? "" : parentPsid)
  }

  showResetPasswordModal = () => {
    this.setState({
      reset_modal_data: {
        ...this.state.reset_modal_data,
        resetPassword: true
      }
    });
  }

  closeModal = () => {
    this.setState({
      reset_modal_data: {
        ...this.state.reset_modal_data,
        resetPassword: false,
        password: "",
        confirmPassword: ""
      }
    });
  };

  onChangePassword = value => {
    this.setState({
      reset_modal_data: {
        ...this.state.reset_modal_data,
        password: value.target.value,

      }
    });
  }

  onChangeConfirmPassword = value => {
    this.setState({
      reset_modal_data: {
        ...this.state.reset_modal_data,
        confirmPassword: value.target.value,

      }
    });
  }

  resetPassword = () => {
    const { reset_modal_data } = this.state;
    const { actions, agent } = this.props;
    if (reset_modal_data.password != reset_modal_data.confirmPassword) {
      showMessage('error', 'Password & Confirm password must be same!');
    } else {
      const payload = {
        email: agent.email,
        password: reset_modal_data.password
      }
      actions.resetPassWord(payload);
      this.closeModal();
    }
  }

  renderCommonForm = () => {
    const { reset_modal_data } = this.state;
    if (reset_modal_data.resetPassword) {
      const first_input_props = {
        title: "Password",
        type: "password",
        placeholder: "Enter new password",
        name: "password",
        value: reset_modal_data.password,
        onChange: this.onChangePassword
      };

      const second_input_props = {
        title: "Confirm Password",
        type: "password",
        placeholder: "Enter new password",
        name: "confirmPassword",
        value: reset_modal_data.confirmPassword,
        onChange: this.onChangeConfirmPassword
      };
      const modal_footer_props = {
        button_ok_text: "Reset",
        handleCancelClick: this.closeModal,
        handleOkClick: this.resetPassword
      };
      return (
        <CommonForm show_first_input first_input_props={first_input_props} show_second_input second_input_props={second_input_props} modal_footer_props={modal_footer_props} />
      );
    }
  };

  render() {
    const { agent, agents, is_other_profile } = this.props;
    const radioStyle = { display: 'block', height: '30px', lineHeight: '30px', fontWeight: 400 };
    return (
      <div className="ori-pad-15">
        <div className="ori-flex-row ori-flex-jfe">
          <Button type="primary" size='small' className="ori-font-xs ori-border-radius-20 ori-lr-pad-15" onClick={this.showResetPasswordModal}>Change Password</Button>
        </div>
        <Row gutter={16} className=" ori-b-pad-10">
          <Col xs={24} sm={12}>
            <InputItem input_class="ori-font-xs ori-input-disabled-bg-white ori-input-disabled-font-xs   ori-input-disabled-color-default" title="First Name" placeholder="First Name" name="firstName" value={agent.firstName} onChange={this.onChangeAgentInfo} suffix={is_other_profile ? <Icon type="lock" theme="filled" /> : ""} disabled={is_other_profile} />
          </Col>
          <Col xs={24} sm={12}>
            <InputItem input_class="ori-font-xs ori-input-disabled-bg-white ori-input-disabled-font-xs   ori-input-disabled-color-default" title="Last Name" placeholder="Last Name" name="lastName" value={agent.lastName} onChange={this.onChangeAgentInfo} suffix={is_other_profile ? <Icon type="lock" /> : ""} disabled={is_other_profile} />
          </Col>
        </Row>
        <Row gutter={16} className="ori-b-pad-10">
          <Col xs={24} sm={12}>
            <InputItem input_class="ori-font-xs ori-input-disabled-bg-white ori-input-disabled-font-xs    ori-input-disabled-color-default" title="Pseudo Name" placeholder="Enter Pseudo Name" name="pseudoName" value={agent.pseudoName} suffix={is_other_profile ? <Icon type="lock" /> : ""} onChange={this.onChangeAgentInfo} disabled={is_other_profile} />
          </Col>
          <Col xs={24} sm={12} className="ori-tb-pad-5">
            <p className='ori-b-mrgn-5 ori-capitalize-first'>Parent</p>
            <Select className='ori-full-width ori-font-xs' placeholder='select parent' filterOption={this.filterOption} value={agent.parentPsid} onChange={this.onChangeAgentParent} allowClear showSearch>
              {
                agents.map(item => {
                  if (item.psid !== agent.psid)
                    return (
                      <Option key={item.psid} value={item.psid}>{`${item.firstName} ${item.lastName}`}</Option>
                    )
                })
              }
            </Select>
          </Col>
        </Row>
        <Row gutter={16} className="ori-b-pad-10">
          <Col xs={24} sm={12}>
            <InputItem input_class="ori-font-xs ori-input-disabled-bg-white ori-input-disabled-font-xs    ori-input-disabled-color-default" title="Title / Designation" placeholder="Title / Designation" name="designation" value={agent.designation} suffix={is_other_profile ? <Icon type="lock" /> : ""} onChange={this.onChangeAgentInfo} disabled={is_other_profile} />
          </Col>
          <Col xs={24} sm={12}>
            <InputItem input_class="ori-font-xs ori-input-disabled-bg-white ori-input-disabled-font-xs ori-input-disabled-color-default" type="email" title="email" placeholder="Email" value={agent.email} suffix={<Icon type="lock" theme="filled" />} disabled />
          </Col>
        </Row>
        <TextareaItem className="ori-border-radius-20 ori-font-md" title="A few words about agent..." minRows={3} maxRows={3} placeholder="Something about agent in 150 characters" name="bio" value={agent.bio} onChange={this.onChangeAgentInfo} />
        <Row gutter={16} className="ori-tb-pad-10">
          <Col xs={24} sm={12} className="ori-tb-pad-5">
            <p className="ori-b-mrgn-5">Status after logging in</p>
            <Radio.Group className="ori-font-default" name="acceptingChatsAfterLogin" value={agent.acceptingChatsAfterLogin} onChange={this.onChangeAgentInfo}>
              <Radio className="ori-font-default ori-capitalize" style={radioStyle} value={AGENT_STATUS.ACCEPTING}>Accept chats</Radio>
              <Radio className="ori-font-default ori-capitalize" style={radioStyle} value={AGENT_STATUS.NOT_ACCEPTING}>{AGENT_STATUS.NOT_ACCEPTING}</Radio>
            </Radio.Group>
          </Col>
          <Col xs={24} sm={12} className="ori-tb-pad-5">
            <p className="ori-b-mrgn-5">Chats limit</p>
            <InputNumber min={0} value={agent.chatConcurrency} onChange={this.onChangeChatConcurrency} />
            <span className="ori-font-ligh ori-l-pad-5">Concurrent chats </span>
          </Col>
        </Row>
        <p className="ori-t-mrgn-10 ori-b-mrgn-5 ori-font-md">Add your social handles</p>
        <SocialInputItem Icon={IconFacebookSquare} icon_class="ori-font-facebook" icon_title="Facebook" type="url" placeholder="Enter your facebook url" name="facebook" value={agent.socialLinks ? agent.socialLinks.facebook : null} onChange={this.onChangeSocialLinks} />
        <SocialInputItem Icon={IconTwitterSquare} icon_class="ori-font-twitter" icon_title="Twitter" type="url" placeholder="Enter your twitter url" name="twitter" value={agent.socialLinks ? agent.socialLinks.twitter : null} onChange={this.onChangeSocialLinks} />
        <SocialInputItem Icon={IconLinkedinSquare} icon_class="ori-font-linkedin" icon_title="Linkedin" type="url" placeholder="Enter your linkedin url" name="linkedin" value={agent.socialLinks ? agent.socialLinks.linkedin : null} onChange={this.onChangeSocialLinks} />
        <Modal className="ori-modal-primary" title="Change Password" footer={null} maskClosable={false} visible={this.state.reset_modal_data.resetPassword} onCancel={this.closeModal}>
          {this.renderCommonForm()}
        </Modal>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({ resetPassWord }, dispatch),
  };
};

AgentForm.propTypes = {
  agent: PropTypes.object,
  agents: PropTypes.array,
  actions: PropTypes.object,
  is_other_profile: PropTypes.bool,
  onChange: PropTypes.func,
};

AgentForm.defaultProps = {
  agent: {},
  agents: [],
  is_other_profile: false,
};

export default connect(null, mapDispatchToProps, null, { withRef: true })(AgentForm);

// export default AgentForm;




// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/members/agents/components/agentform/index.js